import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormatService } from '../../services/format/format.service';
import { StorageService } from '../../services/storage/storage.service';
import { AccountService } from '../../services/account/account.service';

@Component({
  selector: 'app-enter-youtube-complete',
  standalone: true,
  imports: [],
  templateUrl: './enter-youtube-complete.component.html',
  styleUrl: './enter-youtube-complete.component.scss'
})
export class EnterYoutubeCompleteComponent {

  accountService: AccountService = inject(AccountService);
  formatService: FormatService = inject(FormatService);
  storageService: StorageService = inject(StorageService);
  router: Router = inject(Router);

  youtubeAccount: any | undefined;

  ngOnInit() {
    console.log('Enter YouTube complete ---->');
    console.log('Enter YouTube account: ', this.accountService.enterYoutube);

    this.youtubeAccount = this.accountService.enterYoutube;
  }

  exitBrowser() {
    console.log('Exit browser');
    this.router.navigate(['/']);
  }

  connectAnotherAccount() {
    console.log('Connect another account');
    const businessId = this.storageService.get('businessId');
    const externalId = this.storageService.get('externalId');
    this.router.navigate([`/connect/${externalId}/${businessId}`]);
  }
}
